<template>
	<div class="deposit-form">
		<div class="region-tabs">
			<button class="tab-btn" :class="{ active: activeTab === 'tw' }" @click="activeTab = 'tw'" data-tab="tw">
				台灣
			</button>
			<button class="tab-btn" :class="{ active: activeTab === 'hk' }" @click="activeTab = 'hk'" data-tab="hk">
				香港
			</button>
		</div>
		<div class="form-group">
			<label>選擇儲值金額：</label>
			<select v-if="gameCode == 'cztxtw'" class="form-control" v-model="model.productId">
				<option value="">選擇金額：</option>
				<option value="com.cztxtw.huikuan320">TWD10000/HKD2778 (USD 320)</option>
				<option value="com.cztxtw.huikuan640">TWD20000/HKD5556 (USD 640)</option>
				<option value="com.cztxtw.huikuan1600">TWD50000/HKD13889 (USD 1600)</option>
				<option value="com.cztxtw.huikuan2560">TWD80000/HKD22222 (USD 2560)</option>
				<option value="com.cztxtw.huikuan3200">TWD100000/HKD27778 (USD 3200)</option>
			</select>
			<select v-if="gameCode == 'sgyjltw'" class="form-control" v-model="model.productId">
				<option value="">選擇金額：</option>
				<option value="com.sgyjltw.web32000_2_30027">TWD10000/HKD2778 (USD 320)</option>
				<option value="com.sgyjltw.web64000_2_30028">TWD20000/HKD5556 (USD 640)</option>
				<option value="com.sgyjltw.webhk1000_2_30029">TWD31250/HKD8680 (USD 1000)</option>
				<option value="com.sgyjltw.webhk1600_2_30030">TWD50000/HKD13889 (USD 1600)</option>
				<option value="com.sgyjltw.webhk2560_2_30031">TWD80000/HKD22222 (USD 2560)</option>
				<option value="com.sgyjltw.webhk3200_2_30032">TWD100000/HKD27778 (USD 3200)</option>
			</select>
		</div>
		<div class="form-group">
			<label>銀行卡后五位：</label>
			<input v-model="model.bankNo" class="form-control" placeholder="請輸入銀行卡后五位"></input>
		</div>
		<div class="form-group">
			<label>上傳憑證</label>
			<ImageUploader ref="imageUploader" @uploaded="handleUploadSuccess" />
		</div>
		<div class="form-group">
			<label>備註：</label>
			<textarea v-model="model.remark" class="form-control" rows="3" maxlength="100"
				placeholder="請輸入備註信息（選填）"></textarea>
		</div>
		<button class="submit-btn" id="submit_btn" v-on:click="submitBankRemit">提交申請</button>
	</div>
</template>

<script>
import ImageUploader from '@/components/common/ImageUpload.vue';
import {
	isEmpty,
	isNotEmpty
} from '../utils/index.js'
export default {
	name: 'BankRemitForm',
	components: {
		ImageUploader
	},
	data() {
		return {
			activeTab: 'tw',
			gameCode: this.$cache.getGameCode(),
			model: {
				productId: '',
				bankNo: '',
				remark: '',
				imgUrl: ''
			}
		}
	},
	methods: {
		handleUploadSuccess(result) {
			if (result.code == 1000) {
				this.model.imgUrl = result.data.imageUrl;
			}
		},
		validateForm() {
			if (!this.model.productId) {
				this.$toast.error('请选择儲值金額');
				return false;
			}
			if (!this.model.bankNo) {
				this.$toast.error('请输入正确的銀行卡后五位');
				return false;
			}
			if (!this.model.imgUrl) {
				this.$toast.error('请上传憑證圖片');
				return false;
			}
			return true;
		},
		submitBankRemit: function () {
			if (!this.validateForm()) {
				return;
			}
			let _role = this.$cache.getRoleInfo();
			if (isEmpty(_role)) {
				this.$refs.userInfo.openRoleChooseWindow();
				return;
			}
			this.$setLoading('submit_btn', true);

			const data = {
				userId: this.$session.getUserId(),
				gameCode: this.$cache.getGameCode(),
				serverCode: _role.serverCode,
				roleId: _role.roleId,
				roleName: _role.roleName,
				roleLevel: _role.roleLevel,
				serverName: _role.serverName,
				currency: this.activeTab == 'hk' ? "HKD" : "TWD"
			};
			const _param = Object.assign({}, data, this.model);

			this.$axios({
				method: 'POST',
				url: '/web/api/remit/submit',
				params: _param
			})
				.then(response => {
					if (response.code === 1000) {
						this.model = Object.assign({}, {
							productId: '',
							bankNo: '',
							remark: '',
							imgUrl: ''
						});
						this.$refs.imageUploader.removeImage();
						this.$toast.success('提交成功');
					} else {
						this.$toast.error(response.message);
					}
				})
				.catch(error => {
					this.$toast.error('提交失败，请稍后重试' + error);
				})
				.finally(() => {
					this.$setLoading('submit_btn', false);
				});
		},
	}
}
</script>

<style scoped>
.region-tabs {
	display: flex;
	margin-bottom: 20px;
	background: #f5f5f5;
	border-radius: 6px;
	padding: 4px;
}

.tab-btn {
	flex: 1;
	padding: 10px;
	background: none;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	font-size: 15px;
	color: #666;
	transition: all 0.3s;
}

.tab-btn.active {
	color: white;
	font-weight: 600;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tab-btn.active[data-tab="hk"] {
	background: #f31f1c;
	/* 香港蓝色 */
}

.tab-btn.active[data-tab="tw"] {
	background: #03d2ff;
	/* 台湾红色 */
}

.deposit-form {
	margin: 30px auto;
	padding: 20px;
	background: white;
	border-radius: 10px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
	max-width: 700px;
	font-size: 15px;
	color: #666;
}

.form-group {
	margin-bottom: 20px;
}

.form-group label {
	display: block;
	margin-bottom: 8px;
	font-weight: 600;
	color: #666;
}

.form-control {
	width: 100%;
	padding: 10px 12px;
	border: 1px solid #e0e0e0;
	border-radius: 6px;
	font-size: 14px;
	transition: border-color 0.3s;
	box-sizing: border-box;
}

.form-control:focus {
	border-color: #03d2ff;
	outline: none;
	box-shadow: 0 0 0 2px rgba(3, 210, 255, 0.2);
}

.submit-btn {
	background: #03d2ff;
	color: white;
	border: none;
	padding: 11px 24px;
	border-radius: 6px;
	font-size: 15px;
	font-weight: 600;
	cursor: pointer;
	width: 100%;
	transition: background 0.3s;
}

.submit-btn:hover {
	background: #02b8e0;
}


span {
	display: inline-flex;
	align-items: center;
	color: #666;
	/* 灰色文字 */
	font-size: 16px;
	/* 增大字体 */
	font-weight: 500;
	/* 中等粗细 */
}

@media (max-width: 768px) {
	.deposit-form {
		padding: 20px;
	}

	.form-group {
		margin-bottom: 16px;
	}

	.submit-btn {
		padding: 10px 20px;
	}
}
</style>